<template>
  <VpListLayout add-route="link" feature="OTHER_LINK">
    <VpList
      :per-page="10"
      :columns="columns"
      endpoint="cardOtherLinks"
      cache="cardOtherLinks"
      :request-payload="{ query: $options.query }"
      class="vp-h-full"
      ref="list"
      title="Links"
      reorder
      @rowClick="
        $router.push({
          name: 'link',
          params: {
            id: $event.id,
          },
        })
      "
      :params="{ cardId: Number(cardId) }"
      @reorder="
        reorder('cardOtherLinks', $event, {
          cardId: Number(cardId),
        })
      "
      feature="CARDS"
    >
      <template #empty>
        <VpFeature the-key="LINK" #default="{ feature }">
          <VpListEmpty :feature="feature" route="link" />
        </VpFeature>
      </template>
      <template #view="{ item }">
        <VyButton
          :href="item.url"
          target="_blank"
          :icon="$options.icons.OpenInNew"
          label="View"
          class="button--gray button--muted button--rounded button--md"
        />
      </template>
    </VpList>
  </VpListLayout>
</template>

<script>
import reorder from "mixins/reorder.js";
import { OpenInNew } from "icons/icons.js";
import cardOtherLinks from "./collection.gql";

export default {
  query: cardOtherLinks,

  icons: {
    OpenInNew,
  },

  props: {
    cardId: [String, Number],
  },

  mixins: [reorder],

  computed: {
    columns() {
      return [
        { name: "_index", label: "#", fix: true, type: "string" },
        { name: "title", sortable: true, type: "string" },
        { name: "description", type: "string" },
        { name: "url", type: "string", fix: true, label: "Link" },
        {
          name: "view",
          label: "Actions",
          fix: true,
          rowClick: false,
          type: "string",
        },
      ];
    },
  },
};
</script>
